<template>
  <div class="container" style="background-color: #FFFAF4;">
    <HeaderComponent :menu-id="3"></HeaderComponent>
    <div>
      <!-- 标题 -->
      <div class="title-ty" style="padding-bottom: 50px;">
        <div class="title-ty-y">SHUISHI GRADING</div>
        <div class="title-ty-z"><span>机制币送评</span>免责条款</div>
      </div>
      <div style="background-color: #FFFAF4;">
        <div class="tiaokuan-box">
          <div class="tixing"><span>特别提醒:</span> 您一经选择水石评级的服务，即视为接受本承诺全部条款，若您不接受本承诺全部或部分条款，请及时向我们作出说明。</div>
          <p class="p-ty">1. 水石评级结论仅针对送检实物当下真伪、品相负责，不承诺藏品未来市场价格、升值、变现价值，不承担行情波动带来的经济损失；</p>
          <p class="p-ty">2. 不可抗力（火灾、水灾、物流意外、政策变动）导致服务延期、藏品损毁，按物流/保险规则理赔，水石评级不承担超额赔偿；</p>
          <p class="p-ty">3. 私自拆开评级盒，原评级结论失效，不再适用水石评级机制币赔付政策；</p>
          <p class="p-ty">4. 邮寄送评：寄件保价费用由送评方自行承担，保价丢失按快递公司保价协议理赔。</p>
          <p class="p-ty">5. 收到缴费通知后10个工作日内付清服务费；逾期未缴费藏品水石代为保管3个月；超过3个月经3次催告仍未付费，视为送评人放弃藏品所有权，水石有权处置藏品抵扣欠费，余款留存公司。</p>
        </div>
      </div>
        
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.p-ty{
  margin-top: 40px;
}
</style>